import React, { useRef, useImperativeHandle } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { useDebounceFn } from 'ahooks';
import { Icon } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import Tags from '@intelligence/components/GenreSelect/components/Tags';

import type { IBaseProps, ITag } from '@intelligence/components/GenreSelect/types';
import type { ITagDeleteHandler } from '@intelligence/components/GenreSelect/components/Tag';

import '@intelligence/components/GenreSelect/components/CheckedValuesBox/index.scss';

interface ICheckedValuesBoxProps extends IBaseProps {
  tags?: ITag[];
  onSearch?: (payload: string) => void;
  onDeleteItem?: ITagDeleteHandler;
  onDeleteBatch?: () => void;
}

export interface ICheckedValuesBoxInstance {
  clearSearchValue: () => void;
}

const CheckedValuesBox: React.ForwardRefRenderFunction<
  ICheckedValuesBoxInstance,
  ICheckedValuesBoxProps
> = (props, ref) => {
  const { style, className, tags, onSearch, onDeleteItem, onDeleteBatch } = props;

  const { formatMessage } = useIntl();

  const searchInputRef = useRef<HTMLInputElement>(null);

  const clearInputValue = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
    onSearch?.('');
  };

  const handleDelete: ITagDeleteHandler = (value, data) => {
    clearInputValue();
    onDeleteItem?.(value, data);
  };

  const { run: debouncedSearchRun } = useDebounceFn(
    (payload: string) => {
      onSearch?.(payload);
    },
    { wait: 300 },
  );

  // useImperativeHandle(
  //   ref,
  //   () => ({
  //     clearSearchValue: () => {
  //       if (searchInputRef.current) {
  //         searchInputRef.current.value = '';
  //         onSearch?.('');
  //       }
  //     },
  //   }),
  //   [],
  // );

  return (
    <div style={style} className={classnames('intelligence-genre-selected-wrap', className)}>
      <div className="intelligence-genre-selected">
        <Tags
          data={tags}
          onDelete={handleDelete}
          searchInputSlot={
            <input
              ref={searchInputRef}
              className="intelligence-search-input"
              placeholder={formatMessage({ id: `dbi_top_search_zone_here_and` })}
              onChange={(e) => {
                e.persist();
                debouncedSearchRun(e.target.value);
              }}
            />
          }
        />
        <div className="genre-flex">
          {(!!tags?.length || !!searchInputRef?.current?.value) && (
            <span
              className="right-icon-clear"
              onClick={(e) => {
                e.stopPropagation();
                clearInputValue();
                onDeleteBatch?.();
              }}
            >
              <SvgIcon className="right-icon" type="clear-icon" />
            </span>
          )}
          <Icon className="right-icon-search" type="search" />
        </div>
      </div>
    </div>
  );
};

export default CheckedValuesBox;
